import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { PlannerProfileListSearchCriteria } from '../../../../../models';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';
import { ListServerPaginationStateModel } from '../../../../../../common/models';
import { FailedMessagesProfileItemModel } from '../../models/profile/failed-messages-profile-item.model';

@Injectable({
  providedIn: 'root',
})
export class FailedMessagesProfileListService {
  constructor(private http: WrapperHttpService) {}

  getProfileList(
    searchCriteria: PlannerProfileListSearchCriteria,
  ): Observable<ListServerPaginationStateModel<FailedMessagesProfileItemModel>> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}?${getQueryStringFromObject(
      searchCriteria,
    )}`;
    return this.http.withLoading().get<ListServerPaginationStateModel<FailedMessagesProfileItemModel>>(url);
  }
}
